// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__8Yp_I","arrow":"styles_arrow__GoEjW","bg":"styles_bg__Nog3t"};